import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import {
  Alert,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormHelperText,
  FormControl,
  InputAdornment,
  MenuItem,
  InputLabel,
  Select,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import TabsCustom from "../../components/Tabs/Tabs";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import GridPreventivi from "../../components/GrdiPreventivi/gridPreventivi";
import { makeStyles } from "@mui/styles";
import * as yup from "yup";
import { useFormik } from "formik";
import { InputCustom } from "../../components/Input/InputCustom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import axios from "axios";
import useSWR from "swr";
import Loading from "../../components/Loading/loading";
import ErrorCustom from "../../components/Error/Error";
import { importBaseActions } from "../../store/reducers/base";
import { getProductName } from "../../Utility";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { RegionsApi } from "../../v2/api/regions_api";
import { AllegatiUploader } from "../../components/Preventivo/allegati_component";
import DeleteConfigurationButton from "../../components/Layout/DeleteButton";
const Richiesta = () => {
  const count = useSelector(state => state.base);
  const baseActions = importBaseActions();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //nazione
  const [regions, setRegions] = useState({ provinces: [], cities: [] });
  //
  const [checked, setChecked] = useState(true);
  const [boolScont, setBoolScont] = useState(false);
  const [messageError, setMessageError] = useState();
  const [deposit, setDeposit] = useState({ open: false, type: "percentage" });
  const [endClientDeposit, setEndClientDeposit] = useState({ oepn: false, type: "percentage" });

  const formRef = React.useRef(null);

  //const history = useHistory();
  const classes = useStyles();
  const handleChangeCheckbox = (event) => setChecked(event.target.checked);
  const location = useLocation();
  let axiosConfig = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + count.user.token,
    },
  };

  // const fetcher = (url) =>
  //   axios
  //     .post(url, { id: count.idPorta }, axiosConfig)
  //     .then((res) => res.data.data);
  // const { data, error } = useSWR([`${process.env.REACT_APP_API_URL}/categories-steps`], fetcher);
  const [isServiceCustomer, setIsServiceCustomer] = useState('');
  const [data, setData] = useState({
    state: "loading",
    steps: [],
    currentStep: null,
    quote: null,
    customer: null,
    discountError: null,
    depositType: "percentage",
    endClientDepositType: "percentage",
    errors: {}
  });
  const [value, setValue] = useState();
  const [discounts, setDiscounts] = useState({ discount1: true, discount2: false });
  const [endClientDiscounts, setEndClientDiscounts] = useState({ discount1: true, discount2: false });
  
  const getTransportLabel = () => {    
    if (isRegioneSardegna()) return "ESCLUSO (A PREVENTIVO)";
    return formik.values.retailTransport === "include" ? "INCLUSO" : "ESCLUSO";
  };

  const getNomeProvincia = () => {
    const prov = regions.provinces.find(p => p.sigla === formik.values.customClientProvince);
    return prov ? prov.nome : formik.values.customClientProvince ?? "";
  }

  const handleChange = () => {
    // data &&
    //   data.map((el) =>
    //     `/${el.slug}` === location.pathname ? setValue(el.id) : null
    //   );
  };

  // const fetcher3 = (url) =>
  //   axios.post(url, { id: count.quoteId }, axiosConfig).then((res) => {
  //     console.log(res.data.data);
  //     return res.data.data;
  //   });
  // const { data: form, error: errorForm } = useSWR(
  //   [`${process.env.REACT_APP_API_URL}/richiesta-form`, value],
  //   fetcher3
  // );
  const loadRegion = async () => {
    const provinces = await RegionsApi.getProvinces();
    setRegions({ ...regions, provinces });
  }
  const getCities = async (provincia) => {
    try {
      const cities = await RegionsApi.findCities(provincia);
      setRegions({ ...regions, cities });
      console.log(`Cities for province ${provincia}:`, cities);
    } catch (e) {
      setRegions({ ...regions, cities: [] });
    }
  }
  useEffect(() => {
    loadRegion();
    load();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    initialValues: {
      qty: 1,
      customClientName: "",
      customClientAddress: "",
      customClientProvince: "",
      customClientCity: "",
      customClientZipCode: "",
      customClientCountry: "Italia",
      endClientDepositType: "percentage",
      endClientDepositValue: 0,
      endClientTaxRate: 0,
      depositType: "percentage",
      depositValue: 0,
      taxRate: 0,
      retailInstallation: "exclude",
      retailTransport: "include",
      notes: ""
    },
    onSubmit: async (values) => {
      let errors = checkBeforeSave();
      if (errors) return;
      
      setData({ ...data, state: "save" });
      try {
        let res = await axios.post(`${process.env.REACT_APP_API_URL}/richiesta`, {
          quoteId: count.quoteId,
          customClientName: values.customClientName,
          customClientAddress: values.customClientAddress,
          customClientCity: values.customClientCity,
          customClientProvince: values.customClientProvince,
          customClientZipCode: values.customClientZipCode,
          customClientCountry: values.customClientCountry,
          endClientDepositType: values.endClientDepositType,
          endClientDepositValue: values.endClientDepositValue,
          endClientTaxRate: values.endClientTaxRate,
          depositType: values.depositType,
          depositValue: values.depositValue,
          discount1: values.discount1,
          discount2: values.discount2,
          taxRate: values.taxRate,
          endClientDiscount1: values.endClientDiscount1,
          endClientDiscount2: values.endClientDiscount2,
          retailInstallation: values.retailInstallation,
          retailTransport: values.retailTransport,
          notes: values.notes,
        }, axiosConfig);

        if (res.data.success == 1) {
          dispatch(baseActions.setRichiesta(true));

          navigate(`/generaPDF`);
        } else {
          setData({ ...data, discountError: res.data.message, state: "idle", errors: {} });
        }
      } catch (e) {
        console.log(e);
        setData({ ...data, state: "idle" });
      }
    }
  });

  const checkBeforeSave = () => {
    if (!count.user.isCustomer && !isServiceCustomer) return null;

    let errors = {
      customClientName: !formik.values.customClientName,
      customClientCity: !formik.values.customClientCity,
      customClientProvince: !formik.values.customClientProvince,
    };

    formik.setErrors(errors);

    let res = Object.entries(errors).filter(values => values[1]);
    return res.length > 0 ? Object.fromEntries(res) : null;
  }

  const load = async () => {
    let steps = [];
    let currentStep = null;
    try {
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/categories-steps`, { id: count.idPorta, quote_id: count.quoteId }, axiosConfig);
      if (res.data && res.data.data) {
        steps = res.data.data;
        currentStep = findCategoryStep(steps);
      }
    } catch (e) {

    }

    try {
      let quote = null;
      let customer = null;
      let endClientSummary = null;
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/richiesta-form?v=2`, { id: count.quoteId }, axiosConfig);
      if (res.data.success == 1) {
        quote = res.data.data.quote;
        customer = res.data.data.customer;
        setIsServiceCustomer(res.data.data.customer.is_service_customer);
        endClientSummary = quote ? JSON.parse(quote.end_client_summary) : null;

        formik.setValues({
          ...formik.values,
          customClientName: quote?.custom_client_name ?? "",
          customClientAddress: quote?.custom_client_address ?? "",
          customClientProvince: quote?.custom_client_province ?? "",
          customClientCity: quote?.custom_client_city ?? "",
          customClientZipCode: quote?.custom_client_zipcode ?? "",
          customClientCountry: quote?.custom_client_country ?? "Italia",

          depositType: quote?.down_payment_type ?? "percentage",
          depositValue: quote?.down_payment ?? "0",
          discount1: quote?.discount1 ?? "0",
          discount2: quote?.discount2 ?? "0",
          discount3: quote?.discount3 ?? "0",
          retailInstallation: quote?.retail_installation ?? "exclude",
          retailTransport: quote?.retail_transport ?? "include",
          taxRate: quote?.tax_rate ?? "0",
          endClientDepositType: endClientSummary?.downPaymentType ?? "percentage",
          endClientDepositValue: endClientSummary?.downPayment ?? "0",
          endClientTaxRate: endClientSummary?.taxRate ?? "0",
          endClientDiscount1: endClientSummary.discount1 ?? "0",
          endClientDiscount2: endClientSummary.discount2 ?? "0",
          endClientDiscount3: /*quote?.discount3 :*/ "0",
          notes: quote?.notes ?? ""
        });

        setDeposit({ open: false, type: quote ? quote.down_payment_type : "percentage" });
        setEndClientDeposit({ open: false, type: endClientSummary ? endClientSummary.downPaymentType : "percentage" });

        setDiscounts({
          discount2: quote.discount1 && quote.discount1 > 0
        });

        setEndClientDiscounts({
          discount2: endClientSummary && endClientSummary.discount1 ? endClientSummary.discount1 : 0
        });
      }

      setData({
        state: "idle",
        steps: steps,
        currentStep: currentStep,
        quote: quote,
        customer: customer,
        endClientSummary: endClientSummary
      });
    } catch (e) {
      setData({
        state: "error",
        error: e
      });
    }
  }

  const findCategoryStep = (categoriesSteps) => {
    return categoriesSteps.find(cs => `/${cs.slug}` === location.pathname);
  };

  const isRegioneSardegna = () => {
    const prov = regions.provinces.find(p => p.sigla === formik.values.customClientProvince);
    return prov?.regione.toLowerCase() == "sardegna";
  }

  const applyDiscount = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setData({ ...data, state: "refresh" });
    try {
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/update-discount`, {
        quoteId: count.quoteId,
        discount1: formik.values.discount1,
        discount2: formik.values.discount2,
        discount3: 0,//formik.values.discount3,
        taxRate: formik.values.taxRate,
        endClientDiscount1: formik.values.endClientDiscount1,
        endClientDiscount2: formik.values.endClientDiscount2,
        endClientTaxRate: formik.values.endClientTaxRate,
        retailInstallation: formik.values.retailInstallation,
        retailTransport: formik.values.retailTransport,
        customClientName: formik.values.customClientName,
        customClientAddress: formik.values.customClientAddress,
        customClientCity: formik.values.customClientCity,
        customClientProvince: formik.values.customClientProvince,
        customClientZipCode: formik.values.customClientZipCode,
        customClientCountry: formik.values.customClientCountry
      }, axiosConfig);
      console.log("QUOTE RELOAD", res);
      if (res.data.success == 1) {
        let quote = res.data.data.configuration;
        console.log("QUOTE RELOAD", quote);
        let endClientSummary = quote ? JSON.parse(quote.end_client_summary) : null;
        setData({ ...data, quote, endClientSummary, discountError: null, state: "idle" });
      } else {
        setData({ ...data, discountError: res.data.message, state: "idle" });
      }
    } catch (e) {
      setData({ ...data, discountError: null, state: "idle" });
    }
  }

  if ("error" == data.state) return <ErrorCustom message={data.error} route={"dimensioni"} />;

  if ("loading" == data.state) return <Loading />;

  return (
    <LayoutPage>
      <div style={{ flex: "0 0 auto" }}>
        <TopBar />

        <div className={"d-flex justify-content-between p-3"}>
          <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
            <h2 className="h2 fw-bold">
              Nuova configurazione {getProductName(count.idPorta)} (#{count.quoteId})
            </h2>
          </div>
          <div>
            {/* <Button variant={deleteClickCount == 0 ? "outlined" : "contained"} color="error" className="me-3 px-2">
                  <RemoveCircleOutlineOutlinedIcon />
                  <span className="ms-2">{deleteClickCount == 0 ? "ELIMINA" : "CONFERMA"}</span>
              </Button> */}
            <DeleteConfigurationButton 
              quoteId ={count.quoteId}
              currentUser={count.user}
            />
            <Button variant="contained" color="secondary" onClick={() => navigate("/configurations")}>
              <CloseIcon />
              <span className="ms-2">CHIUDI</span>
            </Button>
          </div>
        </div>

        <Grid
          className={classes.root}
          container
          sx={{ justifyContent: "center" }}>
          {data.currentStep && <TabsCustom
            value={data.currentStep.id}
            setValue={setValue}
            id={count.idPorta}
            count={count}
            handleChange={handleChange}
            axios_conf={axiosConfig}
            url={`${process.env.REACT_APP_API_URL}/categories-steps`}
          />}
        </Grid>
      </div>

      <div style={{ flex: "1 1 auto", minHeight: "0" }}>
        <div className="container h-full">
          {!data.quote && (
            <div className="row mt-3">
              <div className="col-12">
                <div className="alert alert-danger">
                  <strong>Attenzione!</strong> Configurazione non valida
                </div>
              </div>
            </div>
          )}

          {data.quote && (
            <div className="row h-full">
              <div className="col-xl-7 p-3" style={{ position: "relative", height: "100%", overflowY: "auto" }}>
                <form>
                  <h5 className="text-primary mb-3">
                    Condizioni di vendita
                    {process.env.NODE_ENV !== "production" && count.user.isCustomer && <label>- Cliente finale</label>}
                    {process.env.NODE_ENV !== "production" && !count.user.isCustomer && <label>- Rivendita</label>}
                  </h5>
                  {process.env.NODE_ENV !== "production" && <label>Cliente finale</label>}
                  <div className="row">
                    <div className="col-12 mt-3">
                      <TextField
                        fullWidth
                        label="Denominazione cliente*"
                        variant="outlined"
                        value={formik.values.customClientName}
                        onChange={(e) => formik.setFieldValue("customClientName", e.target.value)}
                        error={!formik.values.customClientName}
                        disabled={!isServiceCustomer}
                        helperText={!formik.values.customClientName && "Campo obbligatorio"}
                      />
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <TextField
                      fullWidth
                      label="Indirizzo"
                      variant="outlined"
                      value={formik.values.customClientAddress}
                      onChange={(e) => formik.setFieldValue("customClientAddress", e.target.value)}
                      disabled={!isServiceCustomer}
                    // error={erroreQta != null}
                    // helperText={erroreQta}
                    />
                  </div>
                  <div className="row">
                    <div className="col-xl-2 mt-3">
                      <FormControl fullWidth>
                        <InputLabel>Nazione</InputLabel>
                        <Select
                          value={formik.values.customClientCountry}
                          label="Nazione"
                          onChange={(e) => {
                            formik.setValues({
                              ...formik.values,
                              customClientCountry: e.target.value,
                              customClientProvince: "",
                              customClientCity: "",
                              customClientZipCode: ""
                            });
                          }}>
                          <MenuItem value="Italia">Italia</MenuItem>
                          <MenuItem value="Estero">Estero</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    {formik.values.customClientCountry === "Italia" && (<>
                      <div className="col-xl-4 mt-3">
                        <Autocomplete
                          options={regions.provinces}
                          getOptionLabel={(option) => option?.nome ?? ""}
                          value={formik.values.customClientProvince ?? ""}
                          inputValue={getNomeProvincia()}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              formik.setValues({
                                ...formik.values,
                                customClientProvince: newValue.sigla,
                                customClientCity: "",
                                customClientZipCode: ""
                              });

                              getCities(newValue.sigla);
                            } else {
                              formik.setValues({
                                ...formik.values,
                                customClientProvince: "",
                                customClientCity: "",
                                customClientZipCode: "",
                              });

                              setRegions({ ...regions, cities: [] });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Provincia"
                              error={formik.errors.customClientProvince}
                              helperText={
                                formik.errors.customClientProvince ? "Campo obbligatorio" : ""
                              }
                            />
                          )}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason == 'clear') {
                              formik.setValues({
                                ...formik.values,
                                customClientProvince: "",
                                customClientCity: "",
                                customClientZipCode: "",
                              });
                              setRegions({ ...regions, cities: [] });
                            } else if (reason == "input") {
                              formik.setValues({
                                ...formik.values,
                                customClientProvince: newInputValue,
                                customClientCity: "",
                                customClientZipCode: "",
                              });
                              setRegions({ ...regions, cities: [] });
                            }
                          }}
                        />
                      </div>
                      <div className="col-xl-4 mt-3">
                        <Autocomplete
                          options={regions.cities || []}
                          disabled={!isServiceCustomer}
                          getOptionLabel={(option) => option?.nome ?? ""}
                          value={formik.values.customClientCity}
                          inputValue={formik.values.customClientCity ?? ""}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              const capList = JSON.parse(newValue.capList);

                              formik.setValues({
                                ...formik.values,
                                customClientCity: newValue.nome,
                                customClientZipCode: capList.length > 0 ? capList[0] : ""
                              });
                            } else {
                              formik.setValues({
                                ...formik.values,
                                customClientCity: "",
                                customClientZipCode: ""
                              });
                            }
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason == 'clear') {
                              formik.setValues({
                                ...formik.values,
                                customClientCity: "",
                                customClientZipCode: ""
                              });

                              if (regions.cities.length <= 0) {
                                getCities(formik.values.customClientProvince);
                              }
                            } else if (reason == "input") {
                                formik.setValues({
                                  ...formik.values,
                                  customClientCity: newInputValue,
                                  customClientZipCode: "",
                                });
                              }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Città"
                              fullWidth
                              error={formik.errors.customClientCity}
                              helperText={formik.errors.customClientCity && "Campo obbligatorio"}
                            />
                          )}
                        />
                      </div>
                      <div className="col-xl-2 mt-3">
                        <TextField
                          disabled={!isServiceCustomer}
                          fullWidth
                          label="C.A.P."
                          variant="outlined"
                          value={formik.values.customClientZipCode ?? ""}
                          onChange={(e) => formik.setFieldValue("customClientZipCode", e.target.value)}
                        />
                      </div>
                    </>)}
                    {formik.values.customClientCountry === "Estero" && (<>
                      <div className="col-xl-4 mt-3">
                        <TextField
                          fullWidth
                          label="Provincia"
                          variant="outlined"
                          value={formik.values.customClientProvince}
                          onChange={(e) => formik.setFieldValue("customClientProvince", e.target.value)}
                        />
                      </div>
                      <div className="col-xl-4 mt-3">
                        <TextField
                          fullWidth
                          label="Città"
                          variant="outlined"
                          value={formik.values.customClientCity}
                          onChange={(e) => formik.setFieldValue("customClientCity", e.target.value)}
                        />
                      </div>
                      <div className="col-xl-2 mt-3">
                        <TextField
                          fullWidth
                          label="C.A.P."
                          variant="outlined"
                          value={formik.values.customClientZipCode}
                          onChange={(e) => formik.setFieldValue("customClientZipCode", e.target.value)}
                        />
                      </div>
                    </>)}
                  </div>
                  <div className="row mt-2">
                    <div className="col-xl-4">
                      <label className="form-label text-primary mb-1">Aliquota IVA</label>
                      <select className="form-control custom-select" value={count.user.isCustomer ? formik.values.endClientTaxRate : formik.values.taxRate} onChange={(e) => {
                        if (count.user.isCustomer) {
                          formik.setFieldValue("endClientTaxRate", e.target.value);
                        } else {
                          formik.setFieldValue("taxRate", e.target.value);
                        }
                      }
                      }>
                        <option value={0}>0</option>
                        <option value={4}>4</option>
                        <option value={10}>10</option>
                        <option value={22}>22</option>
                      </select>
                    </div>
                    <div className="col-xl-4">
                      <label className="form-label text-primary mb-1">Acconto</label>
                      <div className="input-group">
                        {count.user.isCustomer ?
                          (
                            <>
                              <button className={"btn btn-secondary dropdown-toggle " + (endClientDeposit.open ? "show" : "")} type="button" onClick={() => setEndClientDeposit({ ...endClientDeposit, open: !endClientDeposit.open })}>{endClientDeposit.type == "percentage" ? "%" : "€"}</button>
                              {endClientDeposit.open && (
                                <ul className="dropdown-menu show" style={{ position: "absolute", transform: "translateY(40px)", left: "0" }}>
                                  <li><button type="button" className="dropdown-item" onClick={() => {
                                    formik.setFieldValue("endClientDepositType", "percentage");
                                    formik.setFieldValue("endClientDepositValue", "0");
                                    setEndClientDeposit({ ...endClientDeposit, open: false, type: "percentage" });
                                  }}>%</button></li>
                                  <li><button type="button" className="dropdown-item" onClick={() => {
                                    formik.setFieldValue("endCutomerDepositType", "amount");
                                    formik.setFieldValue("endClientDepositValue", "0");
                                    setEndClientDeposit({ ...endClientDeposit, open: false, type: "amount" });
                                  }}>&euro;</button></li>
                                </ul>
                              )}
                              <input type="number" className="form-control text-right" name="endClientDepositValue" value={formik.values.endClientDepositValue} onChange={(e) => formik.setFieldValue("endClientDepositValue", e.target.value)} />
                            </>
                          ) : (
                            <>
                              <button disabled={!isServiceCustomer} className={"btn btn-secondary dropdown-toggle " + (deposit.open ? "show" : "")} type="button" onClick={() => setDeposit({ ...deposit, open: !deposit.open })}>{deposit.type == "percentage" ? "%" : "€"}</button>
                              {deposit.open && (
                                <ul className="dropdown-menu show" style={{ position: "absolute", transform: "translateY(40px)", left: "0" }}>
                                  <li><button type="button" className="dropdown-item" onClick={() => {
                                    formik.setFieldValue("depositType", "percentage");
                                    formik.setFieldValue("depositValue", "0");
                                    setDeposit({ ...deposit, open: false, type: "percentage" });
                                  }}>%</button></li>
                                  <li><button type="button" className="dropdown-item" onClick={() => {
                                    formik.setFieldValue("depositType", "amount");
                                    formik.setFieldValue("depositValue", "0");
                                    setDeposit({ ...deposit, open: false, type: "amount" });
                                  }}>&euro;</button></li>
                                </ul>
                              )}
                              <input disabled={!isServiceCustomer} type="number" className="form-control text-right" name="depositValue" value={formik.values.depositValue} onChange={(e) => formik.setFieldValue("depositValue", e.target.value)} />
                            </>
                          )
                        }
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-column mt-2">
                    <label className="text-primary">Sconto</label>
                    <div className="row">
                      <div className="col-4">
                        <input
                          type="number"
                          name={"endClientDiscount1"}
                          value={count.user.isCustomer ? formik.values.endClientDiscount1 : formik.values.discount1}
                          onChange={(e) => {
                            if (count.user.isCustomer) {
                              const shouldEnable = value > 0;
                              formik.setFieldValue("endClientDiscount1", e.target.value);
                              if (!shouldEnable) {
                                formik.setFieldValue("endClientDiscount2", 0);
                              }
                            } else {
                              const shouldEnable = value > 0;
                              formik.setFieldValue("discount1", e.target.value);
                              if (!shouldEnable) {
                                formik.setFieldValue("discount2", 0);
                              }
                            }
                          }}
                          onBlur={(e) => {
                            if (count.user.isCustomer) {

                              setEndClientDiscounts({ ...endClientDiscounts, discount2: formik.values.endClientDiscount1 > 0 })
                            } else {
                              setDiscounts({ ...discounts, discount2: formik.values.discount1 > 0 })
                            }
                          }
                          }
                          className="form-control text-center"
                        />
                      </div>

                      <div className="col-4">
                        <input
                          type="number"
                          name={"endClientDiscount2"}
                          value={count.user.isCustomer ? formik.values.endClientDiscount2 : formik.values.discount2}
                          onChange={(e) => {
                            if (count.user.isCustomer) {
                              formik.setFieldValue("endClientDiscount2", e.target.value);
                            } else {
                              formik.setFieldValue("discount2", e.target.value);
                            }
                          }}
                          disabled={count.user.isCustomer ? !endClientDiscounts.discount2 : !discounts.discount2}
                          className="form-control text-center"
                        />
                      </div>
                    </div>

                    {"END_CLIENT_DISCOUNT_ERROR" == data.discountError && (
                      <Alert className="mt-2" severity="error">Sconto non applicabile</Alert>
                    )}
                    {"RETAIL_DISCOUNT_ERROR" == data.discountError && (
                      <Alert className="mt-2" severity="error">Sconto non applicabile</Alert>
                    )}
                  </div>

                  <div className="mt-2">
                    <label className="text-primary">Installazione</label>
                    <div className="row">
                      <div className="col-xl-12">
                        <FormControl fullWidth>
                          <Select
                            labelId="retailInstallation"
                            value={formik.values.retailInstallation}
                            onChange={(e) => {
                              formik.setFieldValue("retailInstallation", e.target.value);
                            }}>
                            <MenuItem value={"exclude"}>ESCLUSA</MenuItem>
                            <MenuItem value={"include"}>INCLUSA</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2">
                    <label className="text-primary">Trasporto</label>
                    <div className="row">
                      <div className="col-xl-12">
                        <FormControl fullWidth>
                          <Select
                            labelId="retailTransport"
                            value={formik.values.retailTransport}
                            disabled={isRegioneSardegna()}
                            onChange={(e) => {
                              formik.setFieldValue("retailTransport", e.target.value);
                            }}
                            displayEmpty
                            renderValue={getTransportLabel}
                          >
                            <MenuItem value="exclude">ESCLUSO</MenuItem>
                            <MenuItem value="include">INCLUSO</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2">
                    <label className="form-label text-primary mb-1">Note</label>
                    <textarea className="form-control" name="notes" value={formik.values.notes} onChange={(e) => formik.setFieldValue("notes", e.target.value)}></textarea>
                  </div>
                  <AllegatiUploader
                    currentUser={count.user}
                    quote_id={count.quoteId}
                  />
                  <div className="d-flex flex-row-reverse mt-2">
                    <Button type="button" variant="outlined" size="medium" onClick={(e) => applyDiscount(e)}>
                      AGGIORNA IMPORTI
                    </Button>
                  </div>
                </form>
              </div>

              <div className="col-xl-5">
                {data.quote && (
                  <div className="mt-1 rounded-3 p-3 bg-light " style={{ position: "relative" }}>
                    <h4 className="h4 fw-bold">Totale:</h4>
                    <div className="d-flex justify-content-between">
                      <NumberItem label="Quantità:" value={data.quote.qty} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale merce:" value={data.quote.base_net_price} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale servizi:" value={data.quote.total_services} />
                    </div>

                    {!count.user.isCustomer && (
                      <>
                        <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                          <hr />
                          {process.env.NODE_ENV != "production" && <small>Rivendita</small>}
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Sconto:" value={-data.quote.total_discount} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale merce netto:" value={data.quote.net} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Costi installazione:" value={data.quote.retail_installation_costs} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale imponibile:" value={data.quote.taxable_amount} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale iva:" value={data.quote.total_taxes} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale ordine:" value={data.quote.total} />
                        </div>
                      </>
                    )}

                    {count.user.isCustomer && data.endClientSummary && (
                      <>
                        <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                          <hr />
                          {process.env.NODE_ENV != "production" && <small>Cliente finale</small>}
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Sconto:" value={-data.endClientSummary.totalDiscount} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale merce netto:" value={data.endClientSummary.net} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Costi installazione:" value={data.quote.retail_installation_costs} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale imponibile:" value={data.endClientSummary.taxableAmount} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale iva:" value={data.endClientSummary.totalTaxes} />
                        </div>

                        <div className="d-flex justify-content-between">
                          <AmountItem label="Totale ordine:" value={data.endClientSummary.total} />
                        </div>
                      </>
                    )}

                    <div className="d-flex flex-row-reverse justify-content-between mt-3">
                      <Button disabled={"save" == data.state} variant="contained" className="ps-3 pe-1" onClick={(e) => formik.handleSubmit(e)}>
                        <span>Genera preventivo</span>
                        <NavigateNextIcon />
                      </Button>

                      <Button variant="contained" className="ps-1 pe-3" color="secondary" onClick={() => navigate("/accessori")}>
                        <NavigateBeforeIcon />
                        <span>Indietro</span>
                      </Button>
                    </div>

                    {"refresh" == data.state && (
                      <div className="d-flex justify-content-center align-items-center" style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }}>
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </LayoutPage>
  );
};

const useStyles = makeStyles({
  root: {
    "& MuiTabs-flexContainer css-heg063-MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
});

const mapState = (state) => ({
  count: state.count,
});

export const AmountItem = (props) => {
  if (!props) return <span>ERRORE</span>;

  return (
    <>
      <h6 className="h6">{props.label}</h6>
      <h6 className="h6 text-primary">
        {Number(props.value)
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")} &euro;
      </h6>
    </>
  );
}

export const NumberItem = (props) => {
  return (
    <>
      <h6 className="h6">{props.label}</h6>
      <h6 className="h6 text-primary">
        {Number(props.value).toFixed(props.decimal || 0)}
      </h6>
    </>
  );
}

export default connect(mapState)(Richiesta);
